import { Field, Form, Formik } from 'formik';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import * as yup from "yup";
import { studentSignup } from "../Redux/AuthReducer/action"
import { getBatch, getSection } from '../Redux/BatchSectionReducer/action';

const FormSchema = yup.object().shape({
    name: yup.string().required("Name is required").min(3, "Name must be 3 character"),
    batch: yup.string().required("Batch is required"),
    section: yup.string().required("Section is required"),
    email: yup.string().required("Email is required").email("Email is invalid"),
    password: yup
        .string()
        .required("Password is required")
        .min(8, "Password must be 8 characters long")
        .matches(/[0-9]/, "Password requires a number")
        .matches(/[A-Z]/, "Password requires a uppercase letter")
        .matches(/[a-z]/, "Password requires a lowercase letter")
        .matches(/[^\w]/, "Password requires a symbol"),
    confirm: yup
        .string()
        .required("Re-enter Password")
        .oneOf([yup.ref("password"), null], "Must match password field value"),
});


export const StudentSignup = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const batch = useSelector((state) => state.BatchSectionReducer.batch);
    const section = useSelector((state) => state.BatchSectionReducer.section);

    useEffect(() => {
        dispatch(getSection());
        dispatch(getBatch());
    }, [])

    return (
        <div className='font-sans text-gray-900 antialiased'>
            <div className='min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100'>
                <div>
                    <img className='h-16' src='https://masaischool.com/img/navbar/logo.svg' alt='MasaiLogo' />
                </div>
                <Formik
                    initialValues={{
                        name: "",
                        email: "",
                        batch: "",
                        section: "",
                        password: "",
                        confirm: ""
                    }}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={FormSchema}
                    onSubmit={(values) => {
                        console.log(values);
                        let data = {
                            name: values.name,
                            email: values.email,
                            batchId: values.batch,
                            sectionId: values.section,
                            password: values.password
                        }
                        dispatch(studentSignup(data))
                            .then((res) => {
                                if (res === "Success") {
                                    navigate('/login')
                                }
                            })
                    }}
                >
                    {({ errors }) => (
                        <Form className='mb-6 text-left flex flex-col gap-y-[10px] w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg'>
                            <div>
                                <label className='block font-medium text-sm text-gray-700'>Name</label>
                                <Field
                                    name='name'
                                    className='text-sm required:border-red-500 p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    type='text'
                                />
                                {errors.name && <p className="text-red-600 text-sm">{errors.name}</p>}
                            </div>
                            <div>
                                <label className='block font-medium text-sm text-gray-700'>Batch</label>
                                <Field
                                    component='select'
                                    name='batch'
                                    className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                >
                                    <option value=''>Select your Batch</option>
                                    {
                                        batch.map((e) => {
                                            return <option key={e.id} value={e.id}>{e.batchName}</option>
                                        })
                                    }
                                </Field>
                                {errors.batch && <p className="text-red-600 text-sm">{errors.batch}</p>}
                            </div>
                            <div>
                                <label className='block font-medium text-sm text-gray-700'>Section</label>
                                <Field
                                    component='select'
                                    name='section'
                                    className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                >
                                    <option value="">Select your section</option>
                                    {
                                        section.map((e) => {
                                            return <option key={e.id} value={e.id}>{e.sectionsName}</option>
                                        })
                                    }
                                </Field>
                                {errors.section && <p className="text-red-600 text-sm">{errors.section}</p>}
                            </div>
                            <div>
                                <label className='block font-medium text-sm text-gray-700'>Email</label>
                                <Field
                                    name='email'
                                    className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    type='email'
                                />
                                {errors.email && <p className="text-red-600 text-sm">{errors.email}</p>}
                            </div>
                            <div>
                                <label className='block font-medium text-sm text-gray-700'>Password</label>
                                <Field
                                    name='password'
                                    className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    type='password'
                                />
                                {errors.password && <p className="text-red-600 text-sm">{errors.password}</p>}
                            </div>
                            <div>
                                <label className='block font-medium text-sm text-gray-700'>Re-enter Password</label>
                                <Field
                                    name='confirm'
                                    className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                    type='password'
                                />
                                {errors.confirm && <p className="text-red-600 text-sm">{errors.confirm}</p>}
                            </div>
                            <div className='flex flex-row gap-4 justify-end font-sans text-gray-900 mt-4'>
                                <div className='mt-1'>
                                <Link className='underline text-sm text-gray-600 cursor-pointer hover:text-gray-900 pt-[3px] pb-[3px]' to='/login'>Already a member? Login</Link>
                                </div>
                                <div>
                                    <button
                                        className='border rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase '
                                        type='submit'
                                    >
                                        Signup
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    )
}
